import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-patientoverview',
  templateUrl: './patientoverview.component.html',
  styleUrls: ['../patient-profile.component.scss', './patientoverview.component.scss']
})
export class PatientoverviewComponent implements OnInit {

  @Input('id') id: any;
  data: any = { status: 0, activities: [], allowNoteTags: false, force_session_report: 0 };
  recommended_therapies: any = [];
  dept: any = "";
  consultant: any = "";
  limit: any = 3;
  selectedRemark: any = {
    category: "",
    title: "",
    consultant: "",
    date: "",
    dept: "",
    tag: "",
    item: {
      id: 0,
      title: "",
      contents: "",

    }

  };
  followupDate: any = "";
  minFollowupDate: string = this.todayString();
  followups: any = [];
  activeAppointment: any = null;
  selectedVisit: any = { report: { id: 0, body: "" } };


  constructor(public dataService: DataService, private router: Router) { }

  ngOnInit() {
    this.loadOverview();
    this.loadFollowups();

  }

  todayString() {
    const d = new Date();
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  loadFollowups() {
    this.dataService.getClientFollowups(this.id).subscribe((res: any) => {
      if (res.status == 0) {
        this.followups = res.data;
      }
    });
  }

  saveFollowup() {
    if (this.followupDate == "") {
      alert("Please select a date");
      return;
    }

    if (this.followupDate < this.minFollowupDate) {
      alert("Followup date cannot be in the past");
      return;
    }

    let data = {
      patient_id: this.id,
      date: this.followupDate
    };

    this.dataService.postClientAddFollowup(data).subscribe((res: any) => {
      if (res.status == 0) {
        alert(res.msg);
        this.followupDate = "";
        this.loadFollowups();
      } else {
        alert(res.msg);
      }
    });
  }



  loadOverview() {
    this.dataService.getClientOverview(this.id, this.dept, this.consultant, this.limit).subscribe((res: any) => {
      this.data = res;
      if (res.active_appointment) {
        this.activeAppointment = res.active_appointment;
      } else {
        this.activeAppointment = null;
      }
    });
  }

  submitNotes(data) {

    data.patient_id = this.id;
    //data.date = $('#note-date').val();
    $('#btn-remarks').attr('disabled', 'true');
    $('#btn-remarks').text('Submitting');
    data.tags = this.recommended_therapies;
    this.dataService.postNotes(data).subscribe((res: any) => {
      if (res.status == 0) {
        alert(res.msg);
        //$('#modalRemarks').modal('hide');
        $('.btn-close-modal').trigger("click");
        $('#btn-remarks').text('Submit');
        this.loadOverview();
      } else {
        alert(res.msg);
      }


    });



  }

  loadRemarks(item) {
    this.selectedRemark = item;
    $("#modalViewRemarks").modal("show");
    console.log(item);
  }

  addTherapy(therapy: string) {
    if (therapy) {
      therapy.split(',')
        .map(t => t.trim())
        .filter(t => t.length > 0)
        .forEach(t => this.recommended_therapies.push(t));

      // Clear the input field after adding
      const inputField = document.getElementById('therapyInput') as HTMLInputElement;
      if (inputField) {
        inputField.value = '';
      }
    }
  }


  removeTherapy(therapy: string) {
    const index = this.recommended_therapies.indexOf(therapy);
    if (index > -1) {
      this.recommended_therapies.splice(index, 1);
    }
  }

  // Tags Logic
  newTag: string = "";
  isEditingTag: boolean = false;
  editingTagIndex: number = -1;

  addTag() {
    if (this.newTag.trim() != "") {
      this.data.tags.push(this.newTag.trim());
      this.newTag = "";
      this.saveTags();
    }
  }

  deleteTag(index: number) {
    this.data.tags.splice(index, 1);
    this.saveTags();
  }

  editTag(index: number) {
    this.newTag = this.data.tags[index];
    this.isEditingTag = true;
    this.editingTagIndex = index;
    // Focus logic could go here if we had a reference to the input
  }

  updateTag() {
    if (this.newTag.trim() != "" && this.editingTagIndex > -1) {
      this.data.tags[this.editingTagIndex] = this.newTag.trim();
      this.isEditingTag = false;
      this.editingTagIndex = -1;
      this.newTag = "";
      this.saveTags();
    }
  }

  cancelEditTag() {
    this.isEditingTag = false;
    this.editingTagIndex = -1;
    this.newTag = "";
  }

  saveTags() {
    let payload = {
      patient_id: this.id,
      tags: this.data.tags
    };
    this.dataService.postUpdateTags(payload).subscribe((res: any) => {
      if (res.status == 0) {
        // Success
      } else {
        alert(res.msg);
      }
    });
  }

  selectVisit(visit) {
    this.selectedVisit = visit;
    console.log(this.selectedVisit);
  }

  markComplete(visit) {


    if (!visit.has_completed) {

      let proceed;
      if (this.data.force_session_report == 1) {
        if (visit.report.id == 0) {
          proceed = false;
          visit.close_on_sr = true;
          this.selectVisit(visit);
          $("#modal-new-sr").modal("show");
        } else {
          proceed = true;
        }
      } else {
        proceed = true;
      }

      if (proceed) {
        visit.has_completed = true;
        var data = { "appointment_id": visit.appointment_id };
        this.dataService.postMarkComplete(data).subscribe((res: any) => {
          if (res.status == 0) {
            this.loadOverview();
            if (res.is_nabidh == 1) {

              //redirect to session report if TBC
              if (res.reportCount == 0) {
                this.router.navigate(["/dashboard/tbc/" + visit.patient_id + "/session-report"]);
              } else {
                //Auto-send T02
                this.dataService.sendNabidhFinalSessionReport(visit.appointment_id).subscribe((data: any) => {
                  //console.log(data);
                });
              }



              //Send nabidh request;
              this.dataService.sendNabidhA03(visit.appointment_id).subscribe((data: any) => {
                //console.log(data);
              });
            } else if (res.billGenerated == true) {
              this.router.navigate(["/dashboard/bill/" + res.billId]);
            }
          } else {
            alert(res.msg);
          }

        });
      }

    }

  }

}



